import { Component, OnDestroy } from "@angular/core";
import { AutenticazioneService } from "@app/shared/services/autenticazione.service";
import { Subscription } from "rxjs";
import { UtenteVO } from "@app/shared/vo/utenteVO";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { ProfiliHelper } from "../helper/profili.helper";
import { EventiStore } from "../store/eventi.store";
import { EventoDTO } from "../dto/eventoDTO";
import { TipoEventoEnum } from "../enum/tipo-evento.enum";
import { ContatoriStore } from "@app/store/contatori-store.store";
import { ContatoriVO } from "../vo/contatoriVO";
import { StatoApplicazioneStore } from "../store/stato-applicazione.store";
import { StatoApplicazioneVO } from "../vo/stato-applicazioneVO";

@Component({
  // tslint:disable-next-line:component-selector
  selector: "menu-app",
  templateUrl: "menu.component.html",
})
export class MenuComponent implements OnDestroy {
  subscription: Subscription;
  subscriptionRiservato: Subscription;
  utente: UtenteVO;
  arrivo: boolean = false;
  arrivoDigitale: boolean = false;
  arrivoCartaceo: boolean = false;
  arrivoRiservato: boolean = false;
  partenzaRiservato: boolean = false;
  partenza: boolean = false;
  partenzaDigitale: boolean = false;
  partenzaCartaceo: boolean = false;
  amministratoreTecnico: boolean = false;
  responsabileServizio: boolean = false;
  redattore: boolean = false;
  estensore: boolean = false;
  estensoreLiq: boolean = false;
  isVerificatoreContabile: boolean = false;
  stampaListeAssegnazione: boolean = false;
  protocollazioneInterna: boolean = false;
  numeroDaAggiornare: String;
  isRgd: boolean = false;

  countBozze: number = 0;

  statoApplicazione: StatoApplicazioneVO;

  private storeSubscription: Subscription;

  constructor(
    private autenticazioneService: AutenticazioneService,
    private eventiStore: EventiStore,
    private statoApplicazioneStore: StatoApplicazioneStore,
    private contatoriStore: ContatoriStore,
    private router: Router
  ) {
    this.statoApplicazioneStore.setOnce();
    this.statoApplicazioneStore.getStato().subscribe((res) => {
      this.statoApplicazione = res;
    });
    this.subscription = autenticazioneService.utenteAnnounced$.subscribe(
      (utenteRicevuto) => {
        // console.log("[MENU] utente ricevuto menu: ", utenteRicevuto);
        this.utente = utenteRicevuto;
        if (this.utente == null || this.utente.profili.length === 0) {
          console.log("[MENU] utente non autenticato");
          // this.router.navigate(["/pages/login"]);
        } else {
          this.verificaAutorizzazioni();
        }
      }
    );

    this.storeSubscription = this.eventiStore
      .getEventi()
      .filter((entry: EventoDTO) => entry != null)
      .subscribe((entry: EventoDTO) => {
        console.log("EVENTO non FILTRATO ", entry);
        if (
          this.utente !== null &&
          this.utente.id === entry.operatore &&
          entry.tipo === TipoEventoEnum.CONTATORE &&
          entry.contatori
        ) {
          const contatori = entry.contatori;
          const map = new Map();
          if (contatori && !(entry.contatori instanceof Map)) {
            for (const [key, value] of Object.entries(contatori)) {
              console.log("key: " + key + ", value: " + value);
              map.set(key, value);
            }
            entry.contatori = map;
          }
          console.log(
            "EVENTO FILTRATO",
            entry,
            entry.contatori.get("countBozzeUd")
          );
          this.countBozze = entry.contatori.get("countBozzeUd");
          this.countBozze = JSON.parse(JSON.stringify(this.countBozze));
          const contatoriVO = new ContatoriVO();
          contatoriVO.numeroBozzeUnitaDoc = this.countBozze;
          this.contatoriStore.setContatori(contatoriVO);
        }
      });
  }
  ngOnDestroy(): void {
    this.storeSubscription.unsubscribe();
  }

  verificaAutorizzazioni() {
    // console.log("[MENU] verificaAutorizzazioni menu", this.utente);
    if (this.utente == null) {
      console.log("[MENU] quin non dovrei passare - utente non autenticato");
      // this.router.navigate(['/pages/500']);
    } else {
      this.resetProfilo();
      this.utente.profili.forEach((element) => {
        if (element.codice === "OPEARR") {
          this.arrivo = true;
        }
        if (element.codice === "RGD") {
          this.isRgd = true;
        }
        if (element.codice === "OPEPAR") {
          this.partenza = true;
        }

        if (element.codice === "AMMTEC") {
          this.amministratoreTecnico = true;
        }

        if (element.codice === "RESPSE") {
          this.responsabileServizio = true;
        }

        if (element.codice === "REDAT") {
          this.redattore = true;
        }

        if (element.codice === "ESTEN") {
          this.estensore = true;
        }

        if (element.codice === "ESTENLIQ") {
          this.estensoreLiq = true;
        }

        if (element.codice === "ESTENLIQ") {
          this.estensoreLiq = true;
        }
        if (element.codice ===  "VERIF_CONT") {
          this.isVerificatoreContabile = true;
        }

        element.autorizzazioni.forEach((autorizzazione) => {
          if (autorizzazione.codice === "AD") {
            this.arrivoDigitale = true;
          }

          if (autorizzazione.codice === "AC") {
            this.arrivoCartaceo = true;
          }

          if (autorizzazione.codice === "PC") {
            this.partenzaCartaceo = true;
          }

          if (autorizzazione.codice === "PD") {
            this.partenzaDigitale = true;
          }

          if (autorizzazione.codice === "AR") {
            this.arrivoRiservato = true;
          }

          if (autorizzazione.codice === "PR") {
            this.partenzaRiservato = true;
          }

          if (autorizzazione.codice === "SL") {
            this.stampaListeAssegnazione = true;
          }

          if (autorizzazione.codice === "PI") {
            this.protocollazioneInterna = true;
          }
        });
      });
    }
  }

  resetProfilo() {
    this.arrivoDigitale = false;
    this.arrivoCartaceo = false;
    this.arrivoRiservato = false;
    this.partenzaRiservato = false;
    this.partenza = false;
    this.partenzaDigitale = false;
    this.partenzaCartaceo = false;
    this.amministratoreTecnico = false;
    this.responsabileServizio = false;
    this.stampaListeAssegnazione = false;
    this.protocollazioneInterna = false;
  }

  /*ngOnDestroy() {
     // prevent memory leak when component destroyed
     this.subscription.unsubscribe();
   }
 */
}
